/**
 * deriveLayout — pure helpers for the desktop-only fluid/compact layout rule.
 *
 * The compact↔fluid (sidebar) layout toggle is **desktop-only** (`>=1024`,
 * `useBreakpoint().desktopSidebar`). Below desktop the fluid sidebar
 * (`aside w-[300px]`) is unusable, so the calendar must fall back to compact
 * rendering — WITHOUT mutating the user's stored `layoutMode` intent. These
 * helpers derive the *effective* state so widening the viewport restores the
 * user's chosen fluid layout automatically.
 *
 * @module deriveLayout
 */

/**
 * Effective fullscreen (fluid sidebar) state. True only when the user has
 * chosen the sidebar layout AND the viewport is at the desktop breakpoint.
 *
 * @param {string} layoutMode  'compact' | 'sidebar' (the user's stored intent)
 * @param {boolean} desktopSidebar  `useBreakpoint().desktopSidebar` (>=1024)
 * @returns {boolean}
 */
export function deriveEffectiveFullscreen(layoutMode, desktopSidebar) {
	return layoutMode === 'sidebar' && !!desktopSidebar;
}

/**
 * Whether the compact↔fluid layout toggle button should be rendered.
 * Desktop-only — hidden below `desktopSidebar`.
 *
 * @param {boolean} desktopSidebar  `useBreakpoint().desktopSidebar` (>=1024)
 * @returns {boolean}
 */
export function shouldShowLayoutToggle(desktopSidebar) {
	return !!desktopSidebar;
}
